import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import {SdfBox, SdfSegmentedControl, SdfShimmer} from "@synerg/react-components";
import {selectProductView, useFetchProductsQuery} from "../../../store";
import {transformProductsToSelect} from "../../../utility/transform/productsApi";
import {useFetchDomainsQuery} from "../../../store/apis/articlesMetaApi";
import ApiExplorerProductViewWithFilter from "../../../components/api-explorer/ApiExplorerListWithFilter";
import {RequestError} from "../../../components/RequestError";
import {PageTitle} from "../../../components/PageTitle";
import Breadcrumb from "../../../components/Breadcrumb";


const mockProducts = [
    {
        "key": "pr-offrg-adp.link.prem",
        "title": "ADP® Link",
        "northAmericaOffering": false,
        "internationalOffering": true
    },
    {
        "key": "hcm-offrg-wfn",
        "title": "ADP Workforce Now®",
        "northAmericaOffering": true,
        "internationalOffering": false
    }

]

function ApiExplorerProductView() {
    let domainsSelect, selectedProduct, bottomUi;
    const {productCode} = useParams();
    const dispatch = useDispatch();
    const breadcrumbPath = [
        {name: 'Home', route: '/'},
        {name: 'APIs'},
        {name: 'API Explorer', route: '/apis/api-explorer'}
    ]
    const viewOptions = [
        {label: 'Grid', value: 'grid'},
        {label: 'List', value: 'list'}
    ]
    const apiExplorerProductView = useSelector(({useApiExplorer}) => useApiExplorer.selectedProductView);

    const productsQuery = useFetchProductsQuery()
    const domainsQuery = useFetchDomainsQuery()
    const productsSelect = transformProductsToSelect(productsQuery.data ||  mockProducts)

    function onHandleSwitchPageView(event) {
        dispatch(selectProductView(event.detail))
    }

    if (domainsQuery?.data) {
        domainsSelect = domainsQuery?.data;
    }

    if (domainsQuery.error) {
        bottomUi = <RequestError/>
    } else if (domainsQuery.isLoading || productsQuery.isLoading) {
        bottomUi = (
            <SdfBox>
                <SdfShimmer rows={3}/>
            </SdfBox>
        )
    } else if (productCode && productsSelect && domainsSelect) {
        selectedProduct = productsSelect?.find((product) => product?.value === productCode) || productsSelect[0];
        breadcrumbPath.push({name: selectedProduct?.label, route: ''})

        bottomUi = (
            <ApiExplorerProductViewWithFilter
                productCode={productCode}
                productsSelect={productsSelect}
                selectedProduct={selectedProduct}
                apiExplorerProductView={apiExplorerProductView}
            />
        )
    }

    return (
        <div className="flex flex-col pb-8 px-12">
            <Breadcrumb path={breadcrumbPath}></Breadcrumb>
            <div className="flex justify-between pb-4">

                <PageTitle
                    text="API Explorer"
                    className="m-0 text-heading-07"
                />
                <SdfSegmentedControl
                    className="h-full my-auto"
                    items={viewOptions}
                    selectedIndex={apiExplorerProductView}
                    onSdfChange={onHandleSwitchPageView}
                />
            </div>
            {bottomUi}
        </div>
    )
}

export default ApiExplorerProductView;
